import { InjectableClass } from '@fino/lib-injection';
import { SidebarSectionController } from './section/sidebarSection.controller';
import _ from 'lodash';

export class SidebarService extends InjectableClass {
  constructor($rootScope) {
    'ngInject';
    super({ $rootScope });

    this.sections = [];
  }

  register(section) {
    if (!(section instanceof SidebarSectionController)) {
      throw new Error(`The sidebar section is not an instance of ${SidebarSectionController}`);
    }
    this.sections.push(section);
  }

  getSectionByName(sectionName) {
    return _.find(this.sections, s => s.sectionTitle === sectionName);
  }

  openSectionByName(sectionName) {
    const section = this.getSectionByName(sectionName);
    this.$rootScope.$broadcast('sidebar.openSection', section);
  }

  toggleSection(section) {
    // Close all but the target section
    _.map(this.sections, s => s !== section && s.close());

    // Broadcast section toggle event
    this.$rootScope.$broadcast('sidebar.toggleSection', section);
  }

  toggleSectionByName(sectionName) {
    const section = this.getSectionByName(sectionName);
    if (section) {
      this.toggleSection(section);
    }
  }

  closeSections() {
    // Reset (close) all section
    _.map(this.sections, s => s.close());
  }

  showFlashMessage(message, type) {
    this.$rootScope.$broadcast('sidebar.showFlashMessage', {
      message,
      type,
    });
  }
}
